import { render, staticRenderFns } from "./App.vue?vue&type=template&id=63076fac"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.110.3_postcss@8.5.28___lodash@4.18.1_vue_19ddaf72b5d417b9fe5979854d4543ee/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports